import { Button, Input, Textarea } from "@convergence/components";
import { useForm } from "react-hook-form";
import { useContactMutation } from "../../api/mutations/contact";
import { useState } from "react";
import Turnstile from "react-turnstile";
import { toast } from "react-toastify";
import { useErrorToast } from "../../lib/useErrorToast";

const initialValues = {
    name: 'june',
    email: 'jdoe@example.com',
    message: 'hello',
}

export default function Contact() {
    const { register, handleSubmit, formState, getValues } = useForm({
        defaultValues: initialValues,
    });

    const [showTurnstile, setShowTurnstile] = useState(false);


    const contactMutation = useContactMutation();

    useErrorToast(contactMutation.error);

    return <div className="h-full w-screen bg-white grid place-items-center overflow-auto">
        <form
            onSubmit={handleSubmit(() => {
                setShowTurnstile(true);
            })}
            className="max-w-sm w-full bg-white flex flex-col gap-4 p-4 font-sans border-black border">
            <h1 className="text-2xl">Contact</h1>
            <div className="flex flex-col gap-4">
                <Input {...register('name')} placeholder="Name" />
                <Input {...register('email')} placeholder="Email" />
                <Textarea {...register('message')} placeholder="Message" rows={4} />
                <Button type="submit">Submit</Button>
            </div>
            {formState.errors.root && <p className="text-red-500">{formState.errors.root.message}</p>}
            {showTurnstile && (
                <Turnstile
                    sitekey={import.meta.env.VITE_TURNSTILE_SITE_KEY as string}
                    onVerify={async (token) => {
                        console.log("token", token);
                        console.log("getValues", getValues());
                        contactMutation.mutate({ ...getValues(), captcha: token }, {
                            onSuccess: () => {
                                toast.success("Message sent");
                                setShowTurnstile(false);
                            }
                        });

                    }}
                    onError={(err) => {
                        console.error(err);
                    }}
                />
            )}
        </form>
    </div>;
}